module.exports = __webpack_public_path__ + "a84ee8eb5ece408af969364b6d25fb72.png";